import { ActionsheetContent } from 'components/action-sheet';
import { theme } from 'styles/configure-theme';

export const ActionsheetContentStyled = ActionsheetContent.withConfig({
  backgroundColor: theme.token('background-pattern'),
  padding: 0,
  _web: {
    overflowY: 'scroll',
  },
});
